export default __webpack_public_path__ + "static/media/pic3.8bb65fca.jpg";